module.exports = __webpack_public_path__ + "assets/cerapro-regular-webfont.60076af7.woff";